import { useEffect, useState } from 'react';
import { WHATS_NEW_CHANGE_EVENT, getUnseenWhatsNew } from '../config/whatsNew';

/**
 * 이 계정이 아직 못 본 새 소식이 있는지 — 프로필 메뉴의 "새 소식" 도트용.
 * 팝업·고객센터에서 본 것으로 기록되면(같은 탭 이벤트, 다른 탭 storage) 바로 꺼진다.
 */
const readHasUnseen = (uid, accountCreatedAt) => getUnseenWhatsNew({ uid, accountCreatedAt }).length > 0;

const useHasUnseenWhatsNew = (uid, accountCreatedAt) => {
  const [hasUnseen, setHasUnseen] = useState(() => readHasUnseen(uid, accountCreatedAt));

  useEffect(() => {
    const update = () => setHasUnseen(readHasUnseen(uid, accountCreatedAt));
    update();
    window.addEventListener(WHATS_NEW_CHANGE_EVENT, update);
    window.addEventListener('storage', update);
    return () => {
      window.removeEventListener(WHATS_NEW_CHANGE_EVENT, update);
      window.removeEventListener('storage', update);
    };
  }, [uid, accountCreatedAt]);

  return hasUnseen;
};

export default useHasUnseenWhatsNew;
